import styled from 'styled-components';
import { Carousel } from 'antd';

export const DetailSection = styled.div`
  background: white;
  padding: ${({ theme }) => theme.spacing.xl};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

export const PriceTag = styled.div`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  margin: ${({ theme }) => theme.spacing.lg} 0;
`;

export const StyledCarousel = styled(Carousel)`
  .slick-dots {
    margin-bottom: 24px;
  }
  .slick-dots li button {
    background: ${({ theme }) => theme.colors.primary};
  }
  .slick-dots li.slick-active button {
    background: ${({ theme }) => theme.colors.primary};
  }
`;

export const NumberCircle = styled.span`
  display: inline-block;
  margin-left: 8px;
  min-width: 22px;
  height: 22px;
  line-height: 22px;
  border-radius: 50%;
  background: ${props => props.color || '#8B5CF6'};
  color: #fff;
  font-weight: bold;
  text-align: center;
  font-size: 15px;
  vertical-align: middle;
`; 